<template>
  <PreChatForm :prechatInputs="inputs" :disabled="activeDataCollectionStatus(id)" :userDetails="userDetails"  :modelData="getFormData" @submit="submitForm" isMidChatForm />
</template>

<script>
import PreChatForm from './PreChatForm.vue'
import { mapActions, mapState } from 'pinia'
import { useWidgetStore } from '@/store'

export default {
  props: {
    inputs: {
      type: Array,
      default: () => ([])
    },
    disabled: {
      type: Boolean,
      default: false
    },
    midChatForm: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    userDetails: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    PreChatForm
  },
  computed: {
    ...mapState(useWidgetStore, [
      'activeDataCollectionStatus',
      'getDataCollectionFormModel'
    ]),
    getFormData () {
      return this.getDataCollectionFormModel(this.id)?.form || {}
    }
  },
  mounted () {
    console.log('MidChatForm mounted', this.userDetails)
  },
  methods: {
    ...mapActions(useWidgetStore, [
      'setDataCollectionStatus',
      'setDataCollectionForm'
    ]),
    getCookie (name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
      if (match) return match[2]
    },
    submitForm (data) {
      this.$emit('submitForm', {
        form: data.form,
        id: this.id
      })
      // save the customer information to global variable "window.digitalData" for Medallia
      if (!this.isFishersci) {
        let chatDigitalData = {}
        // Set Medallia data layer
        window.digitalData.widgets.chat.customer.firstName = data.form?.firstName
        window.digitalData.widgets.chat.customer.lastName = data.form?.lastName
        window.digitalData.widgets.chat.customer.phone = data.form?.phoneNumber
        window.digitalData.widgets.chat.customer.email = data.form?.email
        window.digitalData.widgets.chat.customer.country = this.getCookie?.('CK_ISO_CODE') || window.navigator.language?.split('-')[1]?.toLowerCase()
        window.digitalData.widgets.chat.question = data.form?.subject
        if (window.digitalData.products && window.digitalData.products.length > 0) {
          window.digitalData.widgets.chat.productName = window.digitalData.products[0].name
          window.digitalData.widgets.chat.sku = window.digitalData.products[0].id
        }

        // store the chat data to local storage (since digitalData for chat is re-initialized when the page is refreshed)
        chatDigitalData = { ...window.digitalData.widgets.chat }
        chatDigitalData = JSON.stringify(chatDigitalData)
        localStorage.setItem('chatDigitalData', chatDigitalData)
      }
      this.setDataCollectionStatus(this.id)
      this.setDataCollectionForm({ form: data.form, id: this.id })
    }
  }
}
</script>
